webpackJsonp([1],{

/***/ 113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material_dist_vue_material_css__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material_dist_vue_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_material_dist_vue_material_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tables_2__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(82);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









__WEBPACK_IMPORTED_MODULE_6_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_tables_2__["ClientTable"]);
__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_material___default.a);
__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* default */]);


/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_6_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_0__App___default.a }
});

/***/ }),

/***/ 114:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var actions = {
  /**
   * 郵便番号変更イベント
   */
  customer_postal_cd_changed: function customer_postal_cd_changed(context, _ref) {
    var value = _ref.value;

    value = value.replace(/-/, '');
    if (value.length < 7) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        resolve(false);
      });
    }
    // 郵便番号APIをたたく。
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(location.protocol + '//api.zipaddress.net/?zipcode=' + value).then(function (response) {
      context.commit('edit_customer_address', { data: response.data.data, zipcode: value });
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        resolve(true);
      });
    }).catch(function (error) {
      console.log(error);
    });
  }
};

/***/ }),

/***/ 115:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(43);


// import createLogger from '../../../src/plugins/logger'

var localStoragePlugin = function localStoragePlugin(store) {
  store.subscribe(function (mutation, _ref) {
    var todos = _ref.todos;

    window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_1__mutations__["c" /* STORAGE_KEY */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(todos));
  });
};

/* harmony default export */ __webpack_exports__["a"] = ( false
// ? [createLogger(), localStoragePlugin]
? [localStoragePlugin] : [localStoragePlugin]);

/***/ }),

/***/ 116:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(23);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    name_changed: function name_changed(value) {
      this.$store.commit('edit_customer_name', { value: value });
    },
    postal_cd_changed: function postal_cd_changed(value) {
      var _this = this;

      this.$store.dispatch('customer_postal_cd_changed', { value: value }).then(function (result) {
        if (!result) {
          return;
        }_this.$refs.address1.$el.focus();
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    selected_row: 'selected_row'
  }))
});

/***/ }),

/***/ 118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CustomerDetail__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CustomerDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_CustomerDetail__);
//
//
//
//
//
//
//
//


// import { mapGetters } from 'vuex'
/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.$on('selected_row_value_changed', function (row) {
      var rows = this.tableData.filter(function (x) {
        return x === row;
      });
      console.log(rows.length);
      if (rows.length === 0) {
        return;
      }
      for (var key in ['name', 'postal_cd', 'prefecture', 'city', 'address1', 'phone', 'memo']) {
        rows[0][key] = row[key];
      }
    });
  },
  data: function data() {
    return {
      columns: ['customer_id', 'name', 'postal_cd', 'prefecture', 'city', 'address1', 'phone', 'memo'],
      tableData: this.$store.state.customer_list,
      options: {},
      selected_row: this.$store.state.selected_row
    };
  },

  methods: {
    row_click: function row_click(source) {
      this.$store.state.selected_row = source.row;
    }
  },
  components: { 'customer-detail': __WEBPACK_IMPORTED_MODULE_0__components_CustomerDetail___default.a }
});

/***/ }),

/***/ 119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),

/***/ 120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CustomerList__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CustomerList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_CustomerList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rmp135_vue_splitter__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rmp135_vue_splitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__rmp135_vue_splitter__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {},
  data: function data() {
    var _this = this;

    var order = this.$store.state.order_list.filter(function (x) {
      return x.order_no === _this.$route.params.order_no;
    })[0];
    return {
      order_no: this.$route.params.order_no,
      details: order.details,
      send_customer_id: order.send_customer_id
    };
  },

  methods: {
    delete_order: function delete_order() {
      this.$store.commit('delete_selected_order', { order_no: this.$route.params.order_no });
    }
  },
  components: { 'customer-list': __WEBPACK_IMPORTED_MODULE_0__components_CustomerList___default.a, 'splitter': __WEBPACK_IMPORTED_MODULE_1__rmp135_vue_splitter___default.a }
});

/***/ }),

/***/ 167:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 168:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 169:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 170:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 171:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(168)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(207),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2850d3d0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(169)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(208),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d837d61",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(170)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(120),
  /* template */
  __webpack_require__(209),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-424f6446",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 206:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('md-toolbar', [_c('h1', {
    staticClass: "md-title"
  }, [_vm._v("HighLandirect")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised"
  }, [_vm._v("印刷！")]), _vm._v(" "), _c('span', [_vm._v("ソース："), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://github.com/koty/HighLandirectWebFront"
    }
  }, [_vm._v("https://github.com/koty/HighLandirectWebFront")])])], 1), _vm._v(" "), _c('md-button', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("top")])], 1), _vm._v(" "), _c('md-button', [_c('router-link', {
    attrs: {
      "to": "/customers"
    }
  }, [_vm._v("顧客一覧")])], 1), _vm._v(" "), _c('md-button', [_c('router-link', {
    attrs: {
      "to": "/orders"
    }
  }, [_vm._v("注文一覧")])], 1), _vm._v(" "), _c('md-button', [_c('router-link', {
    attrs: {
      "to": "/orders/o2"
    }
  }, [_vm._v("注文一覧/o2")])], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 207:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-list"
  }, [_c('h2', [_vm._v("顧客詳細")]), _vm._v(" "), _c('form', [_c('md-input-container', [_c('label', [_vm._v("ID")]), _vm._v(" "), _c('md-input', {
    staticClass: "s6",
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.selected_row.customer_id),
      callback: function($$v) {
        _vm.selected_row.customer_id = $$v
      },
      expression: "selected_row.customer_id"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("氏名")]), _vm._v(" "), _c('md-input', {
    on: {
      "change": _vm.name_changed
    },
    model: {
      value: (_vm.selected_row.name),
      callback: function($$v) {
        _vm.selected_row.name = $$v
      },
      expression: "selected_row.name"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("〒")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "postal_cd"
    },
    on: {
      "change": _vm.postal_cd_changed
    },
    model: {
      value: (_vm.selected_row.postal_cd),
      callback: function($$v) {
        _vm.selected_row.postal_cd = $$v
      },
      expression: "selected_row.postal_cd"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("都道府県")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "prefecture"
    },
    model: {
      value: (_vm.selected_row.prefecture),
      callback: function($$v) {
        _vm.selected_row.prefecture = $$v
      },
      expression: "selected_row.prefecture"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("市区町村")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "city"
    },
    model: {
      value: (_vm.selected_row.city),
      callback: function($$v) {
        _vm.selected_row.city = $$v
      },
      expression: "selected_row.city"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("住所")]), _vm._v(" "), _c('md-input', {
    ref: "address1",
    attrs: {
      "id": "address1"
    },
    model: {
      value: (_vm.selected_row.address1),
      callback: function($$v) {
        _vm.selected_row.address1 = $$v
      },
      expression: "selected_row.address1"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("電話番号")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "phone"
    },
    model: {
      value: (_vm.selected_row.phone),
      callback: function($$v) {
        _vm.selected_row.phone = $$v
      },
      expression: "selected_row.phone"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("備考")]), _vm._v(" "), _c('md-textarea', {
    attrs: {
      "rows": "3"
    },
    model: {
      value: (_vm.selected_row.memo),
      callback: function($$v) {
        _vm.selected_row.memo = $$v
      },
      expression: "selected_row.memo"
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 208:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h2', [_vm._v("Essential Links")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Ecosystem")]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Core Docs")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://forum.vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Forum")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://gitter.im/vuejs/vue",
      "target": "_blank"
    }
  }, [_vm._v("Gitter Chat")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/vuejs",
      "target": "_blank"
    }
  }, [_vm._v("Twitter")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuejs-templates.github.io/webpack/",
      "target": "_blank"
    }
  }, [_vm._v("Docs for This Template")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://router.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-router")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuex.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vuex")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vue-loader.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-loader")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/vuejs/awesome-vue",
      "target": "_blank"
    }
  }, [_vm._v("awesome-vue")])])])
}]}

/***/ }),

/***/ 209:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("注文入力")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    on: {
      "click": function($event) {}
    }
  }, [_vm._v("新規注文入力")]), _vm._v(" "), _c('splitter', {
    attrs: {
      "margin": 20
    }
  }, [_c('div', {
    slot: "left-pane"
  }, [_c('div', [_c('span', [_vm._v("注文番号")]), _c('span', [_vm._v(_vm._s(_vm.order_no))]), _vm._v(" "), _c('span', [_vm._v("送り主顧客番号")]), _c('span', [_vm._v(_vm._s(_vm.send_customer_id))])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    on: {
      "click": function($event) {}
    }
  }, [_vm._v("宛先追加")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    on: {
      "click": _vm.delete_order
    }
  }, [_vm._v("選択した宛先を消す")]), _vm._v(" "), _vm._l((_vm.details), function(detail) {
    return _c('li', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (detail.selected),
        expression: "detail.selected"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'ordercheck' + detail.receive_customer_id
      },
      domProps: {
        "checked": Array.isArray(detail.selected) ? _vm._i(detail.selected, null) > -1 : (detail.selected)
      },
      on: {
        "__c": function($event) {
          var $$a = detail.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (detail.selected = $$a.concat($$v))
            } else {
              $$i > -1 && (detail.selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            detail.selected = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'ordercheck' + detail.receive_customer_id
      }
    }, [_vm._v(_vm._s(detail.product_id) + ":" + _vm._s(detail.receive_customer_id))])])
  })], 2), _vm._v(" "), _c('div', {
    slot: "right-pane"
  }, [_c('customer-list')], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 210:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-list"
  }, [_c('h2', [_vm._v("顧客一覧")]), _vm._v(" "), _c('v-client-table', {
    attrs: {
      "data": _vm.tableData,
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "row-click": _vm.row_click
    }
  }), _vm._v(" "), _c('customer-detail', {
    attrs: {
      "selected_row": _vm.selected_row
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STORAGE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mutations; });
var STORAGE_KEY = 'customers-vuejs';

// for testing
if (navigator.userAgent.indexOf('PhantomJS') > -1) {
  window.localStorage.clear();
}

var state = {
  customer_list: [{ customer_id: 1, name: 'にしざわ', 'postal_cd': '381-0001', 'prefecture': '長野県', 'city': '長野市', 'address1': 'あのへん', 'phone': '12-3456-7890', 'memo': 'メモ1' }, { customer_id: 2, name: 'ひがしざわ', 'postal_cd': '381-0002', 'prefecture': '長野県', 'city': '長野市', 'address1': 'このへん', 'phone': '12-3456-7890', 'memo': 'メモ2' }, { customer_id: 3, name: 'きたざわ', 'postal_cd': '381-0003', 'prefecture': '長野県', 'city': '長野市', 'address1': 'そのへん', 'phone': '12-3456-7890', 'memo': 'メモ3' }, { customer_id: 4, name: 'みなみさわ', 'postal_cd': '381-0004', 'prefecture': '長野県', 'city': '長野市', 'address1': 'あっちらへん', 'phone': '12-3456-7890', 'memo': 'メモ4' }],
  order_list: [{ order_id: 1, order_no: 'o1', date: '2017-09-15', send_customer_id: 1, details: [{ receive_customer_id: 2, product_id: 1, selected: false }] }, { order_id: 2, order_no: 'o2', date: '2017-10-15', send_customer_id: 3, details: [{ receive_customer_id: 2, product_id: 1, selected: false }, { receive_customer_id: 1, product_id: 1, selected: true }] }],
  selected_row: { customer_id: 0, name: '', '': '', 'phone': '', 'memo': '' }
};

var mutations = {
  add_customer: function add_customer(state, _ref) {
    var text = _ref.text;

    state.customer_list.push({
      text: text,
      done: false
    });
  },
  delete_customer: function delete_customer(state, _ref2) {
    var todo = _ref2.todo;

    state.customer_list.splice(state.customer_list.indexOf(todo), 1);
  },

  /**
   * 氏名変更イベント
   * @param state
   * @param value
   */
  edit_customer_name: function edit_customer_name(state, _ref3) {
    var value = _ref3.value;

    state.selected_row.name = value;
    var filteredRows = state.customer_list.filter(function (x) {
      return x.customer_id === state.selected_row.customer_id;
    });
    var row = filteredRows[0];
    row.name = value;
  },

  /**
   * 郵便番号変更イベント
   * @param state
   * @param addresses
   */
  edit_customer_address: function edit_customer_address(state, _ref4) {
    var data = _ref4.data,
        zipcode = _ref4.zipcode;

    var filteredRows = state.customer_list.filter(function (x) {
      return x.customer_id === state.selected_row.customer_id;
    });
    var row = filteredRows[0];
    row.postal_cd = zipcode.slice(0, 3) + '-' + zipcode.slice(3, 7);
    row.prefecture = data.pref;
    row.city = data.city;
    row.address1 = data.town;
    state.selected_row = row; // こうしないと明細がrefreshしない...
  },
  delete_selected_order: function delete_selected_order(state, _ref5) {
    var order_no = _ref5.order_no;

    var order = state.order_list.filter(function (x) {
      return x.order_no === order_no;
    })[0];
    for (var i = order.details.length - 1; i >= 0; i--) {
      if (!order.details[i].selected) {
        continue;
      }
      order.details.splice(i, 1);
    }
  }
};

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(171)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(118),
  /* template */
  __webpack_require__(210),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-461fab5d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CustomerList__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CustomerList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_CustomerList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Order__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Order___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Order__);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a
  }, {
    path: '/customers/',
    name: 'CustomerList',
    component: __WEBPACK_IMPORTED_MODULE_3__components_CustomerList___default.a
  }, {
    path: '/orders/:order_no',
    name: 'CustomerList',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Order___default.a
  }]
}));

/***/ }),

/***/ 82:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins__ = __webpack_require__(115);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* state */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* mutations */],
  plugins: __WEBPACK_IMPORTED_MODULE_4__plugins__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* actions */],
  getters: {
    customer_list: function customer_list() {
      return __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* state */].customer_list;
    },
    selected_row: function selected_row() {
      return __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* state */].selected_row;
    }
  }
}));

/***/ }),

/***/ 83:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(167)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(206),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

},[113]);


// WEBPACK FOOTER //
// static/js/app.405fbea1f0467a88f113.js